import React from "react";

import { Grid, GridProps } from "@mui/material";

interface Props extends GridProps {
  children: React.ReactNode;
}
export function Root({ children, ...rest }: Props) {
  return (
    <Grid container direction="row" xs={12} {...rest}>
      {children}
    </Grid>
  );
}
